import { z } from 'zod';
import { parseBooleanFlag } from '@/lib/boolean-flag';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),

  // Non-secret build flag. Truthy ('1'/'true'/'yes'/'on') → map basemaps go
  // through the authenticated Mapbox tile proxy (/metric-hub/map-tiles/*).
  // The Mapbox TOKEN lives only on the API (MAPBOX_TOKEN) — never here.
  // Unset → the token-free Carto basemap. Tolerant parse + boot-time warn on
  // an unrecognized value: a set-but-misspelled secret must not fail silently.
  VITE_MAPBOX_BASEMAP: z
    .string()
    .optional()
    .transform((v) => {
      const { enabled, recognized } = parseBooleanFlag(v);
      if (!recognized) {
        console.warn(
          `[env] VITE_MAPBOX_BASEMAP has unrecognized value ${JSON.stringify(v)} — treating as OFF. Use "1" or "true".`,
        );
      }
      return enabled;
    }),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables. Check .env against env.example');
}

export const env = parsed.data;
